(function () {
  function addRes(target, r) {
    if (r.energy) target.energy += r.energy;
    if (r.anyPower) target.power.any += r.anyPower;
    if (r.pips && r.domains && r.domains[0]) target.power[r.domains[0]] += r.pips;
  }

  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  Object.assign(FX.OPS, {
    jump(state, item, op, p, opp) {
      item.pc += op.n;
      return;
    },

    end(state, item, op, p, opp) {
      item.pc = (item.program || []).length;
      return;
    },

    if(state, item, op, p, opp) {
      const ok = FX.cond(state, item, op.cond);
      if (!ok) item.pc += (op.skip || 1);
      return;
    },

    may(state, item, op, p, opp) {
      if (FX.ask(state, item, "may" + item.pc, {
        player: op.byOpponent ? opp : p, tag: "may", options: ["Yes", "No"],
        prompt: op.prompt || "Optional effect - do it?",
      })) return "wait";
      if (item.vars["may" + item.pc] === 1) {
        item.pc += (op.skip || 1);
      }
      return;
    },

    log(state, item, op, p, opp) {
      FX.opLog(state, item, op.k || "info", op.msg);
      return;
    },

    manual(state, item, op, p, opp) {
      if (!item.vars.manualDone) {
        state.pending = {
          kind: "manual", player: p,
          note: op.note || "Resolve this effect manually, then continue.",
          label: item.label,
        };
        return "wait";
      }
      return;
    },

    option(state, item, op, p, opp) {
      if (FX.ask(state, item, op.varKey || ("opt" + item.pc), {
        player: op.byOpponent ? opp : p, tag: "may", options: op.options,
        prompt: op.prompt || "Choose one",
      })) return "wait";
      return;
    },

    choose(state, item, op, p, opp) {
      if (item.targets[op.bind] !== undefined) return;
      const cands = RB.Play.candidates(state, op.spec, item);
      const min = op.min !== undefined ? op.min : 1;
      if (cands.length < Math.max(1, min)) {
        item.targets[op.bind] = [];
        FX.opLog(state, item, "target", item.label + ": no legal choices.");
        return;
      }
      const allChoose = (item.program || []).filter(function (o2) { return o2.op === "choose"; });
      const doneChoose = allChoose.filter(function (o2) { return item.targets[o2.bind] !== undefined; }).length;
      state.pending = {
        kind: "choose", player: op.byOpponent ? opp : p, tag: "target",
        prompt: op.prompt || "Choose",
        src: item.label, srcIid: item.iid,
        step: allChoose.length > 1 ? { n: doneChoose + 1, of: allChoose.length } : undefined,
        cands: cands, min: min, max: op.max !== undefined ? op.max : 1,
        bind: op.bind,
      };
      return "wait";
    },

    delayed(state, item, op, p, opp) {
      const each = op.forEachSelf ? [item.iid || item.source]
        : op.forEachBind ? (item.targets[op.forEachBind] || []).slice()
        : op.forEach ? FX.resolveRef(state, item, op.forEach) : [null];
      for (const t of each) {
        const fx = {
          id: state.nextFxId++,
          k: "delayedTrigger",
          on: op.on,
          player: op.forPlayer === "controller" ? p : op.forPlayer === "opponent" ? opp : undefined,
          controller: p,
          source: item.source || item.iid || null,
          cardId: Core.cardId(state, item.iid || item.source),
          label: op.label ? op.label.replace("{target}", t ? Core.name(state, t) : "") : item.label,
          program: op.program,
          dur: op.dur || "turn",
        };
        if (op.condSpec) fx.condSpec = op.condSpec;
        if (t) fx.iid = t;
        if (op.carry) {
          fx.carry = {};
          for (const b of op.carry) fx.carry[b] = (item.targets[b] || []).slice();
        }
        if (op.carryVars) {
          fx.carryVars = {};
          for (const v of op.carryVars) fx.carryVars[v] = item.vars[v];
        }
        if (op.repeat) fx.repeat = true;
        if (op.expiresThisTurn) fx.expiresTurn = state.turn.num;
        state.fx.push(fx);
        FX.emit(state, { type: "delayedEffect", iid: t || null, player: p, label: fx.label, on: fx.on });
      }
    },

    prevent(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        state.fx.push({
          id: state.nextFxId++, k: "prevent", iid: t,
          amount: op.amount, dur: op.dur || "turn",
        });
      }
      return;
    },

    preventAll(state, item, op, p, opp) {
      state.fx.push({
        id: state.nextFxId++, k: "preventAll", dur: op.dur || "turn",
        nonCombatOnly: !!op.nonCombatOnly,
        iid: op.self ? item.source : null,
        byEnemyOf: op.fromEnemies ? p : undefined,
      });
      return;
    },

    reEmit(state, item, op, p, opp) {
      const bf = (item.ctx && item.ctx.bf) || null;
      if (!bf) return;
      for (const t of Core.unitsAt(state, { t: "bf", iid: bf }, function (o2) { return o2.controller === p; })) {
        RB.FX.emit(state, { type: op.event, iid: t, bf: bf, player: p });
      }
      return;
    },

    counter(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        if (typeof t === "string" && t.indexOf("chain:") === 0) {
          const id = Number(t.slice(6));
          const target = RB.Play.itemById(state, id);
          if (target && target.iid && (RB.Scripts.forCard(state, target.iid) || {}).uncounterable) {
            FX.opLog(state, item, "counter", target.label + " can't be countered.", [target.iid].filter(Boolean));
            continue;
          }
          if (target && RB.Play.uncounterableFor(state, target.controller)) {
            FX.opLog(state, item, "counter", target.label + " can't be countered.", [target.iid].filter(Boolean));
            continue;
          }
          if (target) {
            item.vars.counteredCtl = target.controller;
            RB.Play.removeChainItem(state, id);
            if (target.iid) {
              const o = state.objs[target.iid];
              if (o && o.zone === "chain") {
                if (op.dest === "hand") Flow.toHand(state, target.iid);
                else if (op.dest === "banish") Flow.toBanish(state, target.iid);
                else Flow.toTrash(state, target.iid);
              }
            }
            FX.opLog(state, item, "counter", target.label + " is countered.", [target.iid].filter(Boolean));
          }
        }
      }
      return;
    },

    setVarLoc(state, item, op, p, opp) {
      let loc = null;
      if (op.from === "evFrom") loc = item.ctx && item.ctx.ev && item.ctx.ev.from;
      else if (op.from === "evTo") loc = item.ctx && item.ctx.ev && item.ctx.ev.to;
      else {
        const refs = FX.resolveRef(state, item, op.from);
        if (refs.length && (state.battlefields || []).indexOf(refs[0]) >= 0) loc = { t: "bf", iid: refs[0] };
        else {
          const o = refs.length && state.objs[refs[0]];
          loc = o && o.loc;
        }
      }
      if (loc) item.vars[op.varKey] = { t: loc.t, iid: loc.iid, p: loc.p };
      return;
    },

    setVarMight(state, item, op, p, opp) {
      const refs = FX.resolveRef(state, item, op.from);
      const m = refs.length ? Core.effMight(state, refs[0]) : 0;
      item.vars[op.varKey] = m === null ? 0 : m;
      return;
    },

    setVarPlayer(state, item, op, p, opp) {
      const refs = FX.resolveRef(state, item, op.of);
      const o = refs.length && state.objs[refs[0]];
      item.vars[op.varKey] = o ? (op.which === "owner" ? o.owner : o.controller) : p;
      return;
    },

    draw(state, item, op, p, opp) {
      let who = op.who === "opponent" ? [opp] : op.who === "each" ? [0, 1] : [p];
      if (op.whoOf) {
        const refs = item.targets[op.whoOf] || [];
        who = [];
        for (const t of refs) {
          const o2 = state.objs[t];
          const w = o2 ? o2.controller : (item.ctx && item.ctx.snapshot && item.ctx.snapshot.controller);
          if (w !== undefined && who.indexOf(w) < 0) who.push(w);
        }
      }
      const n = FX.amount(state, item, op.n === undefined ? 1 : op.n);
      for (const w of who) Flow.draw(state, w, n);
      return;
    },

    burn(state, item, op, p, opp) {
      Flow.burnCards(state, op.who === "opponent" ? opp : p, FX.amount(state, item, op.n === undefined ? 1 : op.n));
      return;
    },

    xp(state, item, op, p, opp) {
      const xpN = FX.amount(state, item, op.n === undefined ? 1 : op.n);
      if (xpN <= 0) return;
      state.players[p].xp += xpN;
      state.turnFacts.players[p].xpGained += xpN;
      FX.opLog(state, item, "resource", state.players[p].name + " gains " + xpN + " XP (" + state.players[p].xp + ").");
      return;
    },

    points(state, item, op, p, opp) {
      const who = op.who === "opponent" ? opp : p;
      state.players[who].points = Math.max(0, state.players[who].points + op.n);
      RB.FX.emit(state, { type: "scored", player: who, n: op.n, source: item.source || item.iid || null });
      FX.opLog(state, item, "score", state.players[who].name + (op.n > 0 ? " gains " : " loses ") + Math.abs(op.n) + " point → " + state.players[who].points + ".");
      state.needCleanup = true;
      return;
    },

    spendXp(state, item, op, p, opp) {
      const n = FX.amount(state, item, op.n === undefined ? 1 : op.n);
      if (state.players[p].xp < n) {
        item.vars[op.varKey || ("spendXp" + item.pc)] = false;
        FX.opLog(state, item, "resource", state.players[p].name + " cannot spend " + n + " XP.");
        return;
      }
      state.players[p].xp -= n;
      item.vars[op.varKey || ("spendXp" + item.pc)] = true;
      FX.opLog(state, item, "resource", state.players[p].name + " spends " + n + " XP (" + state.players[p].xp + " left).");
      return;
    },

    spendBuffs(state, item, op, p, opp) {
      const key = "sb" + item.pc;
      const st = item.vars[key] = item.vars[key] || { spent: 0, asked: [] };
      const cands = RB.Play.candidates(state, op.spec || { type: "unit", friendly: true }, item)
        .filter(function (t) { return state.objs[t].buffs > 0 && st.asked.indexOf(t) < 0; });
      if (cands.length) {
        if (FX.ask(state, item, key + "pick", {
          player: p, tag: "target", cands: cands, min: 0, max: 1,
          prompt: op.prompt || "Spend a buff (choose none to stop)",
        })) return "wait";
        const picks = FX.picksOf(item.vars[key + "pick"]);
        delete item.vars[key + "pick"];
        if (!picks.length) { st.stopped = 1; }
        else {
          const t = picks[0];
          Flow.spendBuff(state, t, p);
          st.spent += 1;
          st.asked.push(t);
          if (op.thenReady) {
            if (!Core.readyBlocked(state, t)) {
              state.objs[t].ready = true;
              RB.FX.emit(state, { type: "ready", iid: t, player: p });
            }
          }
          item.vars[op.varKey || "buffsSpent"] = st.spent;
          return "repeat";
        }
      }
      item.vars[op.varKey || "buffsSpent"] = st.spent;
      return;
    },

    addResources(state, item, op, p, opp) {
      if (op.who === "each" || op.who === "opponent") {
        const who = op.who === "each" ? [p, opp] : [opp];
        for (const w of who) {
          const sub = {};
          for (const k in op) sub[k] = op[k];
          delete sub.who;
          FX.OPS.addResources(state, item, sub, w, Core.otherPlayer(w));
        }
        return;
      }
      const target = RB.Play.restrictedBucket(state.players[p].pool, op.only);
      addRes(target, op.res || {});
      if (op.bonusTag) {
        for (const s of Core.ruleSources(state, "addResourceBonus", { legends: true, controller: p })) {
          for (const bonus of s.rule) {
            if (bonus.tag !== op.bonusTag) continue;
            if (bonus.cond && !RB.Scripts.staticCond(state, s.iid, p, bonus.cond)) continue;
            addRes(target, bonus.res || {});
          }
        }
      }
      return;
    },

    channel(state, item, op, p, opp) {
      const chWho = op.who === "opponent" ? opp : p;
      const before = state.players[chWho].runeDeck.length;
      const chN = FX.amount(state, item, op.n === undefined ? 1 : op.n);
      if (chN <= 0) return;
      Flow.channel(state, chWho, chN, { exhausted: !!op.exhausted });
      item.vars.channeled = before - state.players[chWho].runeDeck.length;
      return;
    },

    readyRunes(state, item, op, p, opp) {
      const n = op.n || 99;
      const exhausted = Core.runesOf(state, p).filter(function (iid) { return !state.objs[iid].ready; });
      if (!exhausted.length) return;
      if (exhausted.length <= n) {
        for (const iid of exhausted) state.objs[iid].ready = true;
        return;
      }
      if (item.vars.readyPick === undefined) {
        state.pending = {
          kind: "choose", player: p, tag: "readyRunes",
          prompt: "Ready which " + n + " rune" + (n > 1 ? "s" : "") + "?",
          cands: exhausted, min: n, max: n, varKey: "readyPick",
        };
        return "wait";
      }
      for (const iid of item.vars.readyPick) {
        const o = state.objs[iid];
        if (o && o.zone === "board" && o.controller === p && Core.isType(state, iid, "rune")) o.ready = true;
      }
      delete item.vars.readyPick;
      return;
    },

    payCost(state, item, op, p, opp) {
      const key = op.varKey || ("pay" + item.pc);
      if (item.vars[key + "Done"]) return;
      const payer = op.who === "opponent" ? opp : p;
      const cost = RB.Play.costFromRes(op.cost, op.domains || null);
      if (!RB.Play.poolPotentialCovers(state, payer, cost, {})) {
        item.vars[key + "Failed"] = 1;
        item.vars[key + "Done"] = 1;
        item.pc += (op.skipOnFail || 0);
        return;
      }
      state.pending = { kind: "pay", player: payer, cost: cost, note: item.label, cancellable: false, varKey: key };
      item.vars[key + "Done"] = 1;
      return "wait";
    },

    payAny(state, item, op, p, opp) {
      const key = op.varKey || "paid";
      if (item.vars[key + "Done"]) return;
      if (item.vars[key + "N"] === undefined) {
        const avail = op.res === "energy"
          ? RB.Play.maxAffordableEnergy(state, p)
          : RB.Play.maxAffordablePower(state, p);
        const options = [];
        for (let i = 0; i <= avail; i++) options.push(String(i));
        if (options.length <= 1) { item.vars[key] = 0; item.vars[key + "Done"] = 1; return; }
        FX.ask(state, item, key + "N", {
          player: p, tag: "may", options: options,
          prompt: op.prompt || ("Pay how much " + (op.res === "energy" ? "Energy" : "Power") + "?"),
        });
        return "wait";
      }
      const n = item.vars[key + "N"];
      if (n > 0) {
        const cost = op.res === "energy"
          ? { energy: n, pips: [], anyPower: 0 }
          : { energy: 0, pips: [], anyPower: n };
        if (FX.askPay(state, item, key + "Paid", p, cost, item.label)) return "wait";
      }
      item.vars[key] = n;
      item.vars[key + "Done"] = 1;
      return;
    },

    restrictPlay(state, item, op, p, opp) {
      let who = p;
      if (op.who === "opponents") who = Core.otherPlayer(p);
      else if (op.who === "countered") {
        if (item.vars.counteredCtl === undefined) return;
        who = item.vars.counteredCtl;
      }
      state.fx.push({
        id: state.nextFxId++, k: "restrictPlay", dur: op.dur || "turn",
        player: who,
        allowType: op.allowType || null,
        banType: op.banType || null,
        toBaseOnly: !!op.toBaseOnly,
        source: item.source || null,
      });
      return;
    },

    nextPlayMod(state, item, op, p, opp) {
      state.nextPlayMods.push({
        id: state.nextFxId++, player: p, turn: state.turn.num,
        cardType: op.cardType || "spell", mod: op.mod, n: FX.amount(state, item, op.n || 0),
        power: FX.amount(state, item, op.power || 0),
        persist: !!op.persist,
        repeatOf: op.repeatOf || undefined,
        source: item.source || null,
      });
      return;
    },

    extraTurn(state, item, op, p, opp) {
      state.extraTurns[p] += 1;
      FX.opLog(state, item, "turn", state.players[p].name + " will take an extra turn.");
      return;
    },

    winGame(state, item, op, p, opp) {
      state.over = { winner: p, how: op.how || item.label };
      FX.opLog(state, item, "game", state.players[p].name + " WINS THE GAME (" + (op.how || item.label) + ")!");
      return;
    },

    unitsEnterReady(state, item, op, p, opp) {
      state.turnFacts.players[p].unitsEnterReady = true;
      return;
    },

    freeHides(state, item, op, p, opp) {
      state.turnFacts.players[p].freeHides = true;
      FX.opLog(state, item, "state", state.players[p].name + " can hide cards for free this turn.");
      return;
    },
  });
})();
